// extracted by mini-css-extract-plugin
export default {"order":"order-details_order__dXbhG","order_color":"order-details_order_color__OQKYp"};